import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import type { MapState } from '@/types/MapState';

export const useMapStore = create<MapState>()(
  persist(
    (set) => ({
      viewState: {
        longitude: 11.566,
        latitude: 48.139,
        zoom: 10,
      },

      selectedFeature: undefined,

      layersControl: {
        levelOfService: false,
        trafficReports: false,
        parking: false,
        marathon2025: false,
        iaa2025: false,
        priorityNetworkFireDepartment: true,
        tumAudimaxEvacuation: false,
        studyArea: true,
      },

      actions: {
        setViewState: (viewState) => set({ viewState }),

        setSelectedFeature: (feature) => set({ selectedFeature: feature }),

        updateLayersControl: (newLayersControl) =>
          set(({ layersControl }) => ({
            layersControl: {
              ...layersControl,
              ...newLayersControl,
            },
          })),
      },
    }),
    {
      name: 'DATSIM/MAP',
      version: 2.1,
      partialize: ({ actions, viewState, ...rest }) => rest,
    },
  ),
);
